import React from "react";

import { Typography, useTheme } from "@material-ui/core";

import Map from "./Map";

const Content: React.FC = () => {
    const theme = useTheme();
    return (
        <>
            <Typography variant="h3" component="div" style={{ fontWeight: theme.typography.fontWeightMedium }} gutterBottom>
                Retail zones
            </Typography>
            <Typography variant="subtitle1" component="div" gutterBottom style={{ paddingBottom: theme.spacing(3) }}>
                A Retail Zone is a boundary created by Dash, grouping stores with a shared retail mission.
                Each store sits within a Retail Zone, and all metrics in this section are based on that Retail Zone.
                Find out more in the FAQ.
            </Typography>
            <Map />
        </>
    );
};

export default Content;
